<template>
	<div>
		<div class="bgCol second">
			<el-form :model="form" :rules="rule" ref="form">
			<div class="item">
				<span class="label">男工用工量:</span>
				<div class="input"  v-if="is_edit===true">
					<el-form-item label="" prop="man_number">
					<el-input class="explain" type="男工用工量" :autosize="{ minRows: 4}" v-model="form.man_number"
						placeholder="请输入男工用工量"></el-input>工/天
					</el-form-item>
				</div>
				<div class="input" v-else style="background-color: white;">
					{{form.man_number}}工/天
				</div>
			</div>
			<br>
			<div class="item">
				<span class="label">女工用工量:</span>
				<div class="input"  v-if="is_edit===true">
					<el-form-item label="" prop="women_number">
					<el-input class="explain" type="number" :autosize="{ minRows: 4}" v-model="form.women_number"
						placeholder="请输入女工用工量"></el-input>工/天
					</el-form-item>
				</div>
				<div class="input" v-else style="background-color: white;">
					{{form.women_number}}工/天
				</div>
			</div>
			
			<div class="item" v-if="is_weather==1">
					<span class="label">任务执行期间天气:</span>
				</div>
				<div class="weather" v-if="is_weather==1">
					   {{work_task_id}}
				</div>
		</el-form>
		</div>
		
	</div>
</template>

<script>

		export default {
			name: "People",
	
			props: {
				women_number: {
					type: String,
					default: ''
				},
				man_number: {
					type: String,
					default: ''
				},
				work_task_id:{
					type: Number,
					default: 0
				},
				is_weather:{
					type: Number,
					default: 0
				},
				is_edit:{
					type:Boolean,
					default:true
				}
				
			},
			data() {
				return {

						 form: {
						 	women_number:this.women_number,
						 	man_number: this.man_number,
						 },
						 rule: {
						 	women_number: [{
						 		required: true,
						 		message: '必选',
						 		trigger: 'blur'
						 	}],
						 	man_number: [{
						 		required: true,
						 		message: '必填',
						 		trigger: 'blur'
						 	}],
						 },
				}
				
				},
				created() {
					 console.log("aaaaaaa"+this.task_complete_status)
					 this.form.task_complete_status=this.task_complete_status
				},
					methods: {
						validateForm () {
						    let flag = null
						    this.$refs['form'].validate(valid => {
						     if (valid) {
						      flag = true
						     } else {
						      flag = false
						     }
						    })
						    return flag
						   }
						
					}
				
			}
		

</script>

<style>
</style>
